<template>
  <div>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header"></slot>
          <div class="row myrow">
            <br /><br />
            <br />
          </div>
          <div class="breadcrumb-wrapp">
            <a href="/requests/">Реестр запросов</a> >
            <span>{{ request.title }}</span>
          </div>
          <div class="h2-title">{{ request.title }}</div>
          <div class="consultations-module-wrapper" v-if="viewRequest">
            <div class="row myrow consultations-row">
              <div class="consultations-col consultations-col-l stl-df-fc">
                <div class="consultations-box">
                  <!--                  <div class="consultations-box__row">
                                      <div class="consultations-h3-title">Тема</div>
                                      <p>
                                        {{ request.item.UF_THEME }}
                                        <a
                                          v-if="request.RULES_USER.IS_EDIT_THEME"
                                          @click="showEditFieldForm('UF_THEME')"
                                          class="link-edit-row"
                                        ></a>
                                      </p>
                                    </div>-->
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Тип</div>
                    <p>{{ request.item.TYPE.NAME }}</p>
                  </div>
                  <div class="consultations-box__row"
                       v-if="request.item.TYPE.UF_TYPE_ID == 8 && request.item.SCONDITION_DZ_NAME">
                    <div class="consultations-h3-title">Отлагательное условие</div>
                    <p>{{ request.item.SCONDITION_DZ_NAME }}</p>
                  </div>
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Проект</div>

                    <p>
                      <template v-if="request.item.UF_PROJECT_ID == 1">
                        {{ request.noProjectTitle }}
                      </template>
                      <router-link
                        v-else
                        :to="{
                          name: 'AddDZ',
                          params: { id: request.item.UF_PROJECT_ID }
                        }"
                      >{{ request.item.PROJECT_UF_NUMBER }}
                        {{ request.item.COMPANY.NAME }}
                      </router-link>
                    </p>
                  </div>
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Создан</div>
                    <p>
                      {{ request.item.INITIATOR.NAME }} {{ request.item.UF_DATE_CREATE }}
                    </p>
                  </div>
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Ответственный</div>
                    <p>
                      {{ request.item.PERFORMER.NAME }}
                      <a
                        v-if="request.RULES_USER.IS_CHANGE_PERFORMER"
                        @click="showEditFieldForm('PERFORMER')"
                        class="link-edit-row"
                      ></a>
                    </p>
                  </div>
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Статус запроса</div>
                    <p>
                      {{ request.item.STATUS.NAME }}
                      <template v-if="request.item.UF_DATE_COMPETION"> {{ request.item.UF_DATE_COMPETION }}</template>
                    </p>
                  </div>
                  <div
                    class="consultations-box__row"
                    v-if="request.item.UF_PERIOD_EXECUTION"
                  >
                    <div class="consultations-h3-title">Срок исполнения</div>
                    <p>
                      {{ request.item.UF_PERIOD_EXECUTION_FORMAT }}
                      <a
                        v-if="request.RULES_USER.IS_EDIT_PERIOD_EXECUTION"
                        @click="showEditFieldForm('UF_PERIOD_EXECUTION')"
                        class="link-edit-row"
                      ></a>
                    </p>
                  </div>
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Запрос</div>
                    <p>
                      {{ request.item.UF_TEXT }}
                      <a
                        v-if="request.RULES_USER.IS_EDIT_TEXT"
                        @click="showEditFieldForm('UF_TEXT')"
                        class="link-edit-row"
                      ></a>
                    </p>
                  </div>

                  <button
                    v-if="request && request.RULES_USER && request.RULES_USER.IS_VIEW_CLOSE_BUTTON == 1"
                    type="button"
                    class="btn btn-default"
                    @click="closeRequest()"
                  >
                    Завершить запрос
                  </button>

                </div>
                <!-- consultations-box -->
                <div
                  class="consultations-box"
                  v-if="request.SETTING.IS_VIEW_APPROVE_AREA"
                >
                  <div
                    class="consultations-box__row"
                    v-if="request.RULES_USER.IS_CHANGE_APPROVE_LIST"
                  >
                    <a @click="showApproversForm()" class="butt butt-blue">{{
                        request.SETTING.TEXT_BUTTON_CHANGE_APPROVE
                      }}</a>
                  </div>
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Согласующие</div>
                  </div>
                  <div class="consultations-box__row">
                    <table class="consultations-box-table">
                      <tbody
                        v-for="(item, index) in request.item
                          .LIST_MAIN_APPROVE_USERS_INFO"
                      >
                      <tr>
                        <td>
                          <b>{{ item.APPROVE_USER_NAME }}</b>
                        </td>
                        <td>
                          <div class="acceptance-box">
                            <template
                              v-if="
                                  item.IS_SET_AGREEMENT &&
                                    item.IS_EMPTY_APPROVE_USER_RESULT
                                "
                            >
                              <a @click="setApprove(1)" class="c-ok"></a>
                              <a
                                @click="setApprove(2)"
                                class="c-close stl-ml-10 stl-mr-10"
                              ></a>
                            </template>
                            <template v-else-if="item.IS_SET_AGREEMENT">
                              <a
                                v-if="item.IS_SET_AGREEMENT"
                                @click="setApprove(1)"
                                :class="{
                                    active:
                                      item.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                        .UF_STATUS_ID === 1
                                  }"
                                class="c-ok"
                              ></a>
                              <a
                                v-if="item.IS_SET_AGREEMENT"
                                @click="setApprove(2)"
                                :class="{
                                    active:
                                      item.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                        .UF_STATUS_ID === 2
                                  }"
                                class="c-close stl-ml-10 stl-mr-10"
                              ></a>
                            </template>

                            <template
                              v-if="
                                  item.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                "
                            >
                                <span
                                  class="acceptance-box__status green"
                                  v-if="
                                    item.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                      .UF_STATUS_ID === 1
                                  "
                                >Согласовано</span
                                >
                              <span
                                class="acceptance-box__status red"
                                v-if="
                                    item.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                      .UF_STATUS_ID === 2
                                  "
                              >Отклонено</span
                              >
                              <span class="acceptance-box__data">{{
                                  item.APPROVE_USER_RESULTS_AGREEMENT
                                    .UF_DATE_CHANGE_STATUS
                                }}</span>
                            </template>

                            <template
                              v-if="
                                  item.APPROVE_USER_RESULTS_AGREEMENT
                                    .HISTORY_AGREEMENT &&
                                    item.APPROVE_USER_RESULTS_AGREEMENT
                                      .HISTORY_AGREEMENT.length
                                "
                            >
                              <a
                                @click="showHistory(item.APPROVE_USER_ID)"
                                v-if="
                                    item.APPROVE_USER_RESULTS_AGREEMENT
                                      .HISTORY_AGREEMENT.length
                                  "
                                class="js-acceptance-butt triangle-butt"
                                :class="{
                                    open: openedHistory(item.APPROVE_USER_ID)
                                  }"
                              ></a>

                              <div
                                class="acceptance-box__history"
                                :class="{
                                    open: openedHistory(item.APPROVE_USER_ID)
                                  }"
                              >
                                <div
                                  v-for="h in item
                                      .APPROVE_USER_RESULTS_AGREEMENT
                                      .HISTORY_AGREEMENT"
                                >
                                    <span
                                      class="acceptance-box__status green"
                                      v-if="h.STATUS.UF_STATUS_ID === 1"
                                    >Согласовано</span
                                    >
                                  <span
                                    class="acceptance-box__status red"
                                    v-if="h.STATUS.UF_STATUS_ID === 2"
                                  >Отклонено</span
                                  >

                                  <span class="acceptance-box__data">{{
                                      h.UF_DATE_CHANGE_STATUS
                                    }}</span>
                                </div>
                              </div>
                            </template>

                            <a
                              @click="showDelegateForm(index)"
                              class="butt butt-sm butt-blue-dark"
                              v-if="
                                  item.IS_VIEW_DELEGATE_BUTT &&
                                    request.RULES_USER.IS_DELEGATE_APPROVE
                                "
                            >Делегировать</a
                            >
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="consultations-second-level"
                        v-for="item2 in item.USER_DELEGATE_LIST"
                      >
                        <td>{{ item2.APPROVE_USER_NAME }}</td>
                        <td>
                          <div class="acceptance-box">
                            <a
                              v-if="item2.IS_SET_AGREEMENT"
                              @click="
                                  delegateAgreement(1, item2.APPROVE_USER_ID)
                                "
                              :class="{
                                  active:
                                    !item2.IS_EMPTY_APPROVE_USER_RESULT &&
                                    item2.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                      .UF_STATUS_ID === 1
                                }"
                              class="c-ok"
                            ></a>
                            <a
                              v-if="item2.IS_SET_AGREEMENT"
                              @click="
                                  delegateAgreement(2, item2.APPROVE_USER_ID)
                                "
                              :class="{
                                  active:
                                    !item2.IS_EMPTY_APPROVE_USER_RESULT &&
                                    item2.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                      .UF_STATUS_ID === 2
                                }"
                              class="c-close stl-ml-10 stl-mr-10"
                            ></a>
                            <div v-if="!item2.IS_EMPTY_APPROVE_USER_RESULT">
                                <span
                                  class="acceptance-box__status green"
                                  v-if="
                                    item2.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                      .UF_STATUS_ID === 1
                                  "
                                >Согласовано</span
                                >
                              <span
                                class="acceptance-box__status red"
                                v-if="
                                    item2.APPROVE_USER_RESULTS_AGREEMENT.STATUS
                                      .UF_STATUS_ID === 2
                                  "
                              >Отклонено</span
                              >

                              <span class="acceptance-box__data">{{
                                  item2.UF_DATE_CHANGE_STATUS
                                }}</span>
                            </div>

                            <a
                              @click="showHistoryDel(item2.APPROVE_USER_ID)"
                              v-if="
                                  !item2.IS_EMPTY_APPROVE_USER_RESULT &&
                                    item2.APPROVE_USER_RESULTS_AGREEMENT
                                      .HISTORY_AGREEMENT.length
                                "
                              class="js-acceptance-butt triangle-butt"
                              :class="{
                                  open: openedHistoryDel(item2.APPROVE_USER_ID)
                                }"
                            ></a>
                            <div
                              class="acceptance-box__history"
                              :class="{
                                  open: openedHistoryDel(item2.APPROVE_USER_ID)
                                }"
                            >
                              <div
                                v-for="h in item2
                                    .APPROVE_USER_RESULTS_AGREEMENT
                                    .HISTORY_AGREEMENT"
                              >
                                  <span
                                    class="acceptance-box__status green"
                                    v-if="h.STATUS.UF_STATUS_ID === 1"
                                  >Согласовано</span
                                  >
                                <span
                                  class="acceptance-box__status red"
                                  v-if="h.STATUS.UF_STATUS_ID === 2"
                                >Отклонено</span
                                >

                                <span class="acceptance-box__data">{{
                                    h.UF_DATE_CHANGE_STATUS
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- consultations-box -->
                <div
                  class="consultations-box consultations-box-documents"
                  id="consultations-box-documents-l"
                >
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Документы</div>
                  </div>
                  <div class="consultations-box-documents-l-area">
                    <div
                      class="consultations-box__doc-col"
                      v-for="(file, index) in request.item.FILES"
                    >
                      <div class="consultations-chat__holder-files-area-item">
                        <div class="consultations-chat__holder-files-area-item__file-data">
                          <div class="consultations-box__doc-file doc-file-def"
                               style="flex-direction: column; align-items: flex-start"
                               :class="{
                          'doc-file-pdf':
                            file.CONTENT_TYPE === 'application/pdf',
                          'doc-file-xls':
                            file.CONTENT_TYPE === 'application/vnd.ms-excel' ||
                            file.CONTENT_TYPE ===
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                            file.CONTENT_TYPE ===  'application/octet-stream',
                          'doc-file-docs':
                            file.CONTENT_TYPE === 'application/msword' ||
                            file.CONTENT_TYPE ===
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                        }">
                            <a
                              @click="openFileLink(index)"
                            >
                          <span
                            v-bind:class="{
                                'document-file-request-delete': file.IS_DELETE_FILE === 1}"
                          >
                            {{ file.FILE_NAME }}
                          </span>
                            </a>

                            <span
                              v-if="file.TIME_LOADED"
                              style="display: inline-block;vertical-align: middle; font-size: 12px;padding-top: 3px;"
                            >
                          {{ file.TIME_LOADED }}
                        </span>
                          </div>
                        </div>
                        <a
                          v-if="file.IS_RULES_DELETE_FILE && request.RULES_USER.IS_ALL_RULES_EDIT"
                          @click="deleteFile(file)"
                          class="del-butt"></a>
                      </div>
                      <div
                        class="file-upload"
                        v-if="file.IS_RULES_UPDATE && request.RULES_USER.IS_ALL_RULES_EDIT" style="z-index: 2;"
                      >
                        <a class="butt butt-sm butt-blue-dark butt-pointer_">Обновить</a>
                        <input
                          type="file"
                          name="file"
                          ref="file"
                          :index="index"
                          @change="changeFile"
                          style="width: 156px; height: 60px;"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="file-upload-container"
                       v-if="request.RULES_USER.IS_RULES_ADD_FILE && request.RULES_USER.IS_ALL_RULES_EDIT">
                    <div
                      class="file-upload"
                    >
                      <div class="file-upload">
                        <button type="button" class="btn btn-primary">
                          Загрузить документ
                        </button>
                        <input
                          type="file"
                          name="addfile"
                          ref="file"
                          @change="addFile"
                        />
                      </div>
                    </div>
                  </div>

                </div>
                <!-- consultations-box-documents-l -->
              </div>
              <!-- consultations-col stl-df-fc -->
              <div class="consultations-col consultations-col-r stl-df-fc">
                <div class="consultations-box">
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title stl-mb-30">
                      Переписка по запросу
                    </div>
                  </div>
                  <div class="consultations-chat-container">
                    <div class="consultations-chat-wrapper">
                      <div
                        class="consultations-chat__holder"
                        v-for="(item, index) in requestChat.items"
                      >
                        <div class="consultations-chat__holder-author">
                          <div class="consultations-chat__holder-author-name">
                            {{ item.AUTHOR.NAME }}
                          </div>
                          <div class="consultations-chat__holder-author-data">
                            {{ item.UF_DATE_CREATE }}
                          </div>
                        </div>
                        <!-- consultations-chat__holder-author -->
                        <div class="consultations-chat__holder-area">
                          <div class="consultations-chat__holder-content">
                            <div class="consultations-chat__holder-text">
                              <a
                                @click="editMessage(index)"
                                href="#editMess"
                                v-if="item.IS_EDIT_MESSAGE && request.RULES_USER.IS_ALL_RULES_EDIT"
                                class="link-edit-row link-edit-chat js-edit-chat"
                              ></a>
                              <div v-html="item.UF_MESSAGE"></div>
                            </div>
                            <div
                              class="consultations-chat__holder-files"
                              v-if="item.FILES && item.FILES.length"
                            >
                              <b class="title">Файлы:</b>
                              <div class="consultations-chat__holder-files-area">
                              <span
                                class="consultations-chat__holder-files-area-item"
                                v-for="file in item.FILES"
                                v-bind:class="{
                                'document-file-request-delete': file.UF_FILE_ID_DELETE === 1}"
                              >
                                <a
                                  @click="
                                    openChatFileLink(
                                      file.FILE_ID,
                                      file.CONTENT_TYPE
                                    )
                                  "
                                  :disabled="isBlockLink"
                                  class="consultations-box__doc-file doc-file-def"
                                  :class="{
                                  'doc-file-pdf':
                                    file.CONTENT_TYPE === 'application/pdf',
                                  'doc-file-xls':
                                    file.CONTENT_TYPE === 'application/vnd.ms-excel' ||
                                    file.CONTENT_TYPE ===
                                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                    file.CONTENT_TYPE ===  'application/octet-stream',
                                  'doc-file-docs':
                                    file.CONTENT_TYPE === 'application/msword' ||
                                    file.CONTENT_TYPE ===
                                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                }"
                                >{{ file.FILE_NAME }}</a
                                >
                                <a
                                  v-if="request.RULES_USER.IS_ALL_RULES_EDIT"
                                  @click="deleteChatFile(item.ID, file.FILE_ID)"
                                  class="del-butt"
                                ></a>
                              </span>
                              </div>
                              <br />
                            </div>
                          </div>
                          <a
                            v-if="request.RULES_USER.IS_ALL_RULES_EDIT"
                            @click="replyByUserMessage(item.AUTHOR)"
                            class="consultations-chat__reply"
                          >Ответить</a
                          >
                        </div>
                        <!-- consultations-chat__holder-area -->
                      </div>
                      <!-- consultations-chat__holder -->
                    </div>
                    <!-- consultations-chat-wrapper -->
                    <Pagination
                      :pages="pages"
                      :currentPage.sync="currentPage"
                    />
                    <!-- consultations-chat-pagination -->
                  </div>
                  <!-- consultations-chat-container -->
                  <a id="editMess"></a>
                  <div
                    class="consultations-chat-controll"
                    v-if="request.RULES_USER.IS_CHAT_SEND_MESSAGE"
                  >
                    <div class="consultations-chat-controll__redactor">
                      <vue-editor
                        ref="editor"
                        v-model="editorData"
                        :editor-toolbar="toolbar"
                        :editorOptions="editorSettings"
                        @text-change="findCharEnter"
                      />
                    </div>
                    <div class="consultations-chat-controll__butt">
                      <div
                        v-if="file.name"
                        class="form-group"
                        v-for="(file, index) in fileList"
                      >
                        <div class="form-group__file-name">
                          {{ file.name }} {{ file.size }}
                          <i
                            class="i-delete "
                            title="Удалить запись"
                            @click="deleteFileItem(index)"
                          ></i>
                        </div>
                      </div>
                      <div
                        class="file-upload"
                        v-for="(file, index) in fileList"
                        v-show="file.showed"
                      >
                         <div class="file-upload">
                          <button type="button" class="btn btn-primary">
                            Загрузить документ
                          </button>
                          <input
                            v-show="file.showed"
                            type="file"
                            name="file"
                            ref="chatfile"
                            :index="index"
                            @change="changeChatFile"
                          />
                        </div>
                      </div>

                      <div style="display: inline-block">
                        <a @click="sendMessage"
                           class="butt butt-green"
                           v-if="!disableSendNewMessageChat"
                        >Отправить</a
                        >
                        <a @click="clearMessage" class="butt butt-gray"
                        >Отмена</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- consultations-box -->
                <div
                  class="consultations-box consultations-box-documents"
                  id="consultations-box-documents-r"
                >
                  <div class="consultations-box__row">
                    <div class="consultations-h3-title">Вложенные файлы</div>
                  </div>
                  <div class="consultations-chat__holder-files-area">
                    <div
                      class="consultations-chat__holder-files-area-item --full"
                      v-for="(file, index) in requestChat.allListChatFiles"
                      v-bind:class="{
                                'document-file-request-delete': file.UF_FILE_ID_DELETE === 1}"
                    >
                      <a
                        @click="openFileAllChatLink(index)"
                        :disabled="isBlockLink"
                        class="consultations-box__doc-file doc-file-def"
                        :class="{
                          'doc-file-pdf':
                            file.CONTENT_TYPE === 'application/pdf',
                          'doc-file-xls':
                            file.CONTENT_TYPE === 'application/vnd.ms-excel' ||
                            file.CONTENT_TYPE ===
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                          'doc-file-docs':
                            file.CONTENT_TYPE === 'application/msword' ||
                            file.CONTENT_TYPE ===
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                        }"
                      >{{ file.FILE_NAME }}</a
                      >
                    </div>
                  </div>
                </div>
                <!-- consultations-box-documents-r -->
              </div>
              <!-- consultations-col stl-df-fc -->
            </div>
            <!-- row -->
          </div>
        </div>
      </div>
      <div
        class="modal fade in"
        v-bind:class="{ show: showEditField }"
        tabindex="-1"
        role="dialog"
      >
        <form v-on:submit.prevent="sendField">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  v-on:click="showEditField = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Редактирование параметров запроса</h4>
              </div>
              <div class="modal-body">
                <div class="form-group" v-if="editField.field === 'UF_THEME'">
                  <label>Тема</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editField.value"
                  />
                </div>
                <div class="form-group" v-if="editField.field === 'UF_TEXT'">
                  <label>Запрос</label>
                  <textarea class="form-control" v-model="editField.value">
                  </textarea>
                </div>
                <div
                  class="form-group"
                  v-if="editField.field === 'UF_PERIOD_EXECUTION'"
                >
                  <label>Срок исполнения</label>
                  <datepicker
                    v-model="editField.value"
                    :language="ru"
                    :monday-first="true"
                    input-class="form-control"
                  ></datepicker>
                </div>
                <div
                  class="form-group"
                  v-if="
                    editField.field === 'UF_PERFORMER_ID' ||
                      editField.field === 'PERFORMER'
                  "
                >
                  <label>Ответственный</label>

                  <multiselect
                    label="FIO"
                    style="width: 540px;height: 20px"
                    class="form-control form-control-multy-request"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="editField.value"
                    :options="request.SETTING.PERFORMER_LIST_CHANGE_REQUEST"
                    placeholder=""
                  >
                    <span slot="noResult">Исполнитель не найден</span>
                  </multiselect>
                  <!--<select class="form-control"
                          v-model="editField.value"
                  >
                    <option
                      :key="item.ID"
                      v-for="item in request.SETTING
                        .PERFORMER_LIST_CHANGE_REQUEST"
                      :value="item.ID"
                      v-text="item.FIO"
                    ></option>
                  </select>-->
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  v-on:click="showEditField = false"
                >
                  Отмена
                </button>
                <button type="submit" class="btn btn-primary">
                  Редактировать
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <div
        v-if="showChangeApprove"
        class="modal fade in show"
        tabindex="-1"
        role="dialog"
      >
        <form v-on:submit.prevent="sendApprovers">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  v-on:click="showChangeApprove = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Изменение состава согласующих</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <Multiselect
                    label="FIO"
                    style="width: 540px;height: 100px"
                    class="form-control"
                    :limit="10"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="approvers"
                    :options="request.SETTING.APPROVE_LIST_CHANGE_REQUEST"
                    :multiple="true"
                    placeholder=""
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  v-on:click="showChangeApprove = false"
                >
                  Отмена
                </button>
                <button type="submit" class="btn btn-primary">
                  Редактировать
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <div
        v-if="showChangeDelegate"
        class="modal fade in show"
        tabindex="-1"
        role="dialog"
      >
        <form v-on:submit.prevent="sendDelegate">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  v-on:click="showChangeDelegate = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Изменение состава согласующих</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <Multiselect
                    label="FIO"
                    style="width: 540px;height: 100px"
                    class="form-control"
                    :limit="10"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="delegats"
                    :options="request.SETTING.APPROVE_LIST_CHANGE_REQUEST"
                    :multiple="true"
                    placeholder=""
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  v-on:click="showChangeDelegate = false"
                >
                  Отмена
                </button>
                <button type="submit" class="btn btn-primary">
                  Редактировать
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>

      <!-- Удалить файл  -->
      <div
        class="modal fade in"
        tabindex="-1"
        v-bind:class="{ show: showDialogDeleteFile }"
        role="dialog"
      >
        <form>
          <div class="modal-dialog modal-new-style modal-dialog-centered" role="document">
            <div class="modal-content"
                 style="max-width:350px; margin: 0 auto;">
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">
                  Удалить файл?
                </h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <p>
                    Вы действительно хотите удалить файл?
                  </p>
                </div>
              </div>
              <div class="modal-footer" style="justify-content:center">
                <button
                  type="button"
                  class="butt-stl butt-black"
                  data-dismiss="modal"
                  v-on:click="showDialogDeleteFile = false"
                >
                  отменить
                </button>
                <button
                  type="button"
                  v-on:click="deleteFileAction()"
                  class="butt-stl butt-red"
                >
                  Удалить
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>

    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div
          class="footer-sabmit"
          style="padding-left: 20px;"
          v-if="
            (request &&
            request.RULES_USER) &&
            (request.RULES_USER.IS_VIEW_CLOSE_BUTTON == 1 ||
            request.RULES_USER.IS_VIEW_WITHDRAW_BUTTON == 1)
          "
        >
<!--
          <button
            v-if="request && request.RULES_USER && request.RULES_USER.IS_VIEW_CLOSE_BUTTON == 1"
            class="but-style-request but-save"
            @click="closeRequest()"
          >
            Завершить запрос
          </button>
-->

          <button
            v-if="request && request.RULES_USER && request.RULES_USER.IS_VIEW_WITHDRAW_BUTTON == 1"
            class="but-style-request but-ext"
            @click="withDrawRequest()"
          >
            Отозвать запрос
          </button>
        </div>

        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>
    <button
      type="button"
      @mousedown="setQuoteSelections"
      class="popup_tag"
      id="popup_tag"
      ref="popupTag"
    >
      <img
        src="/images/block-quote.svg"
        alt=""
        style="transform: rotate(180deg); width: 32px;"
      />
    </button>
  </div>
</template>

<script>
import Vue from "vue";
import { AUTH_URL } from "@/common/config";
import {
  FETCH_DIRECTORIES,
  FETCH_REQUEST,
  FETCH_REQUEST_CHAT,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { RequestsService, ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import Pagination from "@/components/Pagination";
import Multiselect from "vue-multiselect";
import ForbiddenPage403 from "@/components/ForbiddenPage403.vue";
import NotFoundPage404 from "@/components/NotFoundPage404.vue";

export default {
  name: "RequestEdit",
  components: {
    Pagination,
    Datepicker,
    Multiselect
  },
  data() {
    return {
      ru: ru,
      viewRequest: false,
      showEditField: false,
      showUploadFile: false,
      showChangeApprove: false,
      showChangeDelegate: false,
      delegateUserID: 0,
      approvers: [],
      delegats: [],
      editField: {
        value: "",
        name: "",
        field: ""
      },
      history: {},
      historyDel: {},
      editorData: "",
      editorId: 0,
      currentPage: 1,
      chatFile: { name: "" },
      fileList: [],
      toolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6]
          }
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: ""
          },
          {
            align: "center"
          },
          {
            align: "right"
          },
          {
            align: "justify"
          }
        ],
        ["blockquote", "code-block"],
        [
          {
            list: "ordered"
          },
          {
            list: "bullet"
          },
          {
            list: "check"
          }
        ],
        [
          {
            indent: "-1"
          },
          {
            indent: "+1"
          }
        ], // outdent/indent
        [
          {
            color: []
          },
          {
            background: []
          }
        ], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button
      ],
      editorSettings: {
        modules: {
          mention: {
            allowedChars: /^[A-Za-zА-Яа-я\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            source: this.chatUsers
          }
        }
      },
      isBlockLink: false,
      idDeleteFileTemp: 0,
      deleteFileTemp: '',
      showDialogDeleteFile: false,
      disableSendNewMessageChat: false
    };
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
      this.isEdit = data.IS_REDACT_GROUP_ORG;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }*/
        if (data.IS_VIEW_REQUEST_MODULE) {
          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }*/

        if (data.IS_VIEW_REQUEST_MODULE) {
          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
    });

    this.$store.dispatch(FETCH_DIRECTORIES, [
      "hl/request_status",
      "hl/request_type"
    ]);
    this.fetchItem();

    document.addEventListener("mouseup", function() {
      const popTag = document.getElementById("popup_tag");
      const selection = window.getSelection();
      const selectionText = selection.toString();
      if (selectionText.length > 0) {
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        popTag.style.display = "block";
        popTag.style.position = "fixed"; // fixed positioning = easy mode
        popTag.style.top = rect.top * 0.85 + "px"; // set coordinates
        popTag.style.left = rect.right + 10 + "px";
      }
    });

    document.addEventListener("mousedown", function() {
      const popTag = document.getElementById("popup_tag");
      if (window.getSelection().toString().length > 0) {
        popTag.style.display = "none";
      }
    });
  },

  methods: {
    setQuoteSelections() {
      let selection = window.getSelection().toString();
      if (selection.length > 0) {
        const popTag = document.getElementById("popup_tag");
        //this.$refs.editor.quill.insertEmbed(this.$refs.editor.quill.getLength(), "blockquote", "");
        //this.$refs.editor.quill.insertText(0, selection);
        this.editorData += "<blockquote>" + selection + "</blockquote>";

        window.getSelection().removeAllRanges();
        popTag.style.display = "none";
      }
    },
    chatUsers(searchTerm, renderList, mentionChar) {
      let values = [];

      if (mentionChar === "@") {
        this.requestChat.adressatUserList.forEach(function(v) {
          values.push({ id: v.ID, value: v.NAME });
        });
      }

      if (searchTerm.length === 0) {
        renderList(values, searchTerm);
      } else {
        const matches = [];
        for (let i = 0; i < values.length; i++)
          if (
            ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
          ) {
            matches.push(values[i]);
          }
        renderList(matches, searchTerm);
      }
    },
    fetchItem() {
      this.$store.dispatch(FETCH_REQUEST, this.$route.params.id)
        .then(() => {
        if (this.request.RULES_USER.IS_READ) {
          this.viewRequest = true;
          this.fetchChat();
          this.fillFiles();
        }
      }).catch( error => {
        if (error.message.includes("HttpCode:403")) {
          this.$router.push({ name: "ForbiddenPage403" });
        }
        if (error.message.includes("HttpCode:404")) {
          this.$router.push({ name: "NotFoundPage404" });
        }

      });
    },
    fetchChat() {
      this.$store.dispatch(FETCH_REQUEST_CHAT, this.listConfig).then(() => {
      });
    },
    showEditFieldForm(field) {
      this.showEditField = true;
      this.editField.field = field;
      this.editField.value = this.request.item[field];
    },
    sendField() {
      if (this.editField.value.ID > 0) {
        //смена ответсвенного

        RequestsService.changePerformer(this.$route.params.id, {
          UF_PERFORMER_ID: this.editField.value.ID
        }).then(({ data }) => {
          if (data.error) {

            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);


          } else {
            this.fetchItem();
            this.showEditField = false;

            this.$toasted.show(
              "Запрос на изменение ответственного успешно выполнен",
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              }
            );
          }
        });
      } else {
        RequestsService.editRequestField(
          this.$route.params.id,
          this.editField.field,
          {
            VALUE: this.editField.value
          }
        ).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.fetchItem();
            this.showEditField = false;

            this.$toasted.show("Запрос на изменение успешно выполнен", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });
          }
        });
      }
    },
    openFileLink(i) {
      this.isBlockLink = true;
      RequestsService.getLinkTemplateConformityUrl(
        this.$route.params.id,
        this.request.item.FILES[i].FILE_ID,
        this.request.item.FILES[i].TYPE_APPLICATION
      ).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );

        this.isBlockLink = false;
      });
    },
    openFileAllChatLink(i) {
      this.isBlockLink = true;
      RequestsService.getLinkTemplateConformityUrl(
        this.$route.params.id,
        this.requestChat.allListChatFiles[i].FILE_ID,
        this.requestChat.allListChatFiles[i].TYPE_APPLICATION
      ).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );

        this.isBlockLink = false;
      });
    },
    openChatFileLink(fid, type) {
      this.isBlockLink = true;
      RequestsService.getLinkDownloadFileChatRequest(
        this.$route.params.id,
        fid,
        type
      ).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
        this.isBlockLink = false;
      });
    },
    getRandomInt() {
      let rand = Math.floor(Math.random() * 10001);
      return rand;
    },
    changeFile(e) {
      let formData = new FormData();
      formData.append("UF_FILE_ID", e.target.files[0]);

      RequestsService.downloadFileRequest(
        this.$route.params.id,
        this.request.item.FILES[e.target.getAttribute("index")].FILE_ID,
        formData
      ).then(() => {
        this.fetchItem();
      });
    },
    addFile(e) {
      let formData = new FormData();
      formData.append("UF_FILE_ID", e.target.files[0]);

      RequestsService.downloadFileRequest(
        this.$route.params.id,
        1,
        formData
      ).then(() => {
        this.fetchItem();
      });
    },
    deleteFile(file) {
      this.deleteFileTemp = file;
      this.idDeleteFileTemp = file.FILE_ID;
      this.showDialogDeleteFile = true;
    },
    deleteFileAction() {
      this.showDialogDeleteFile = false;
      RequestsService.deleteFileRequest(
        this.$route.params.id,
        this.idDeleteFileTemp
      ).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });

            }, this);
          } else {
            this.idDeleteFileTemp = 0;
            this.fetchItem();
          }
      });

    },
    setApprove(status) {
      RequestsService.changeResultsMainAgreement(this.$route.params.id, {
        UF_STATUS_ID: status
      }).then(() => {
        this.fetchItem();
      });
    },
    delegateAgreement(status, id) {
      RequestsService.changeResultsDelegateAgreement(this.$route.params.id, {
        UF_STATUS_ID: status,
        UF_MAIN_AGREEMENT_USER_ID: id
      }).then(() => {
        this.fetchItem();
      });
    },
    showApproversForm() {
      this.approvers = [];
      this.request.item.LIST_MAIN_APPROVE_USERS_INFO.forEach(t => {
        this.approvers.push({
          ID: t.APPROVE_USER_ID,
          FIO: t.APPROVE_USER_NAME
        });
      });
      this.showChangeApprove = true;
    },
    sendApprovers() {
      let appr = [];
      this.approvers.forEach(t => {
        appr.push(t.ID);
      });
      RequestsService.changeApprove(this.$route.params.id, {
        UF_LIST_MAIN_APPROVE_USERS_ID: appr
      }).then(() => {
        this.fetchItem();
        this.showChangeApprove = false;
      });
    },
    showDelegateForm(d) {
      this.delegats = [];
      this.request.item.LIST_MAIN_APPROVE_USERS_INFO[
        d
        ].USER_DELEGATE_LIST.forEach(t => {
        this.delegats.push({
          ID: t.APPROVE_USER_ID,
          FIO: t.APPROVE_USER_NAME
        });
      });
      this.delegateUserID = this.request.item.LIST_MAIN_APPROVE_USERS_INFO[
        d
        ].APPROVE_USER_ID;
      this.showChangeDelegate = true;
    },
    sendDelegate() {
      let appr = [];
      this.delegats.forEach(t => {
        appr.push(t.ID);
      });
      RequestsService.changeDelegateApprove(this.$route.params.id, {
        UF_LIST_DELEGATE_APPROVE_USERS_ID: appr,
        UF_MAIN_AGREEMENT_USER_ID: this.delegateUserID
      }).then(() => {
        this.fetchItem();
        this.showChangeDelegate = false;
      });
    },
    showHistory(i) {
      Vue.set(this.history, i, this.history[i] ? 0 : 1);
    },
    openedHistory(i) {
      return this.history[i];
    },
    showHistoryDel(i) {
      Vue.set(this.historyDel, i, this.historyDel[i] ? 0 : 1);
    },
    openedHistoryDel(i) {
      return this.historyDel[i];
    },
    changeChatFile(e) {
      let index = e.target.getAttribute("index");
      this.fileList[index].name = e.target.files[0].name;
      this.fileList[index].size = this.humanFileSize(e.target.files[0].size);
      this.fileList[index].showed = false;
      index++;
      if (this.fileList[index]) {
        this.fileList[index].showed = true;
      }
    },
    deleteFileItem(index) {
      this.$refs.chatfile[index].value=''
      this.fileList.splice(index, 1);
      this.fileList.push({
        isAdded: false,
        showed: false,
        name: ""
      });
      let sLast = true;
      this.fileList.forEach(v => {
        if (v.showed === true) {
          sLast = false;
        }
      });
      if (sLast) {
        this.fileList[this.fileList.length - 1].showed = true;
      }
    },
    fillFiles() {
      this.fileList = [];
      for (let i = 0; i < 3; i++) {
        this.fileList.push({
          isAdded: false,
          showed: i === 0,
          name: ""
        });
      }

      for (let i = 0; i < 3; i++) {
        if (this.$refs.chatfile[i]) {
          this.$refs.chatfile[i].value = ''
        }
      }
    },
    clearMessage() {
      this.editorData = "";
      this.editorId = 0;
      this.fillFiles();
    },
    sendMessage() {
      this.disableSendNewMessageChat = true;
      let formData = new FormData();
      formData.append("UF_MESSAGE", this.editorData);
      //formData.append("UF_FILE_ID", this.$refs.chatfile.files[0]);
      let isAdd = false;
      if (this.fileList.length > 0) {
        this.fileList.forEach(function(file) {
          if (file.name !== "") {
            isAdd = true;
          }

        }, this);

      }
      if (isAdd) {
        for (let v = 0; v < this.$refs.chatfile.length; v++) {
          for (let i = 0; i < this.$refs.chatfile[v].files.length; i++) {
            if (this.fileList[v].name != "") {
              formData.append("UF_FILE_ID[]", this.$refs.chatfile[v].files[i]);
            }
          }
        }
      }

      if (!this.editorId)
        RequestsService.createChatMessageRequest(
          this.$route.params.id,
          formData
        ).then(({ data }) => {
            if (data.error) {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            } else {
              this.editorData = "";
              this.fetchChat();
              this.fillFiles();
            }
            this.disableSendNewMessageChat = false;
        });
      else
        RequestsService.editChatMessageRequest(
          this.$route.params.id,
          this.editorId,
          formData
        ).then( ({ data }) => {
            if (data.error) {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            } else {
              this.editorData = "";
              this.editorId = 0;
              this.fileList = [];
              this.fetchChat();
              this.fillFiles();
            }
            this.disableSendNewMessageChat = false;
        });
    },
    editMessage(i) {
      this.editorId = this.requestChat.items[i].ID;
      this.editorData = this.requestChat.items[i].UF_MESSAGE;
    },
    replyByUserMessage(author) {
      this.editorId = 0;
      this.$refs.editor.quill
        .getModule("mention")
        .insertItem(
          { id: author.UF_AUTHOR_ID, value: author.NAME, denotationChar: "@" },
          true
        );
    },
    replaceString(idUser, nameUser) {
      return (
        "<a class=\"frp-chat-user-name\" href=\"#\" frp-chat-user-id=\"" +
        idUser +
        "\">" +
        nameUser +
        "</a>"
      );
    },
    filterItemText(count) {
      return `и еще ${count}`;
    },
    closeRequest() {
      if (confirm("Вы действительно хотите закрыть запрос?")) {
        RequestsService.closeRequest(this.$route.params.id).then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 6000
            });
          } else {
            this.fetchItem();
            this.showEditField = false;

            this.$toasted.show("Запрос закрыт", {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            });
          }
        });
      }
    },
    withDrawRequest() {
      if (confirm("Вы действительно хотите отозвать запрос?")) {
        RequestsService.withdrawRequest(this.$route.params.id).then(
          ({ data }) => {
            if (data.error) {
              this.$toasted.show(data.errorArr[0].TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 6000
              });
            } else {
              this.fetchItem();
              this.showEditField = false;

              this.$toasted.show("Запрос отозван", {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              });
            }
          }
        );
      }
    },
    findCharEnter() {
      /*this.editorData = this.editorData.replace(
        /@/g,
        this.replaceString(1, "Юзер")
      );*/
    },
    deleteChatFile(mes, file) {
      RequestsService.deleteChatMessageRequestFile(
        this.$route.params.id,
        mes,
        file
      ).then(() => {
        this.fetchChat();
      });
    },
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = ["кБ", "МБ", "ГБ", "TB", "PB", "EB", "ZB", "YB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
        );

      return bytes.toFixed(dp) + " " + units[u];
    }
  },
  computed: {
    ...mapGetters([
      "request",
      "requestChat",
      "addProjectError",
      "isExpsLoading",
      "currentUser",
      "directory"
    ]),
    listConfig() {
      const q = {
        id: this.$route.params.id,
        page: this.currentPage,
        limit: this.itemsPerPage
      };
      return q;
    },
    pages() {
      if (
        this.isRequestsLoading ||
        !this.requestChat.counts ||
        this.requestChat.counts <= 10
      ) {
        return [];
      }
      return [...Array(Math.ceil(this.requestChat.counts / 10)).keys()].map(
        e => e + 1
      );
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchChat();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchChat();
    }
  }
};
</script>

<style scoped>
.popup_tag {
  display: none;
  cursor: pointer;
}
</style>
